import {BaseObject} from './BaseObject';
import {DocumentType} from './DocumentType';

export class DocumentLink extends BaseObject {
    documentId: number;
    document: Document;
    documentType: DocumentType;
    id: number;
    linkedDocumentId: number;
    totalPaid: number;
    totalPrice: number;

}



// WEBPACK FOOTER //
// /app/src/model/Entities/DocumentLink.ts